/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Boards Configuration API
 * API for managing board configurations, settings, and metadata
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Get all board configurations
 */
export const getBoardsConfig200ResponseDataItemNameThMax = 100;

export const getBoardsConfig200ResponseDataItemNameEnMax = 100;

export const getBoardsConfig200ResponseDataItemNameJaMax = 100;

export const getBoardsConfig200ResponseDataItemDescriptionThMax = 255;

export const getBoardsConfig200ResponseDataItemDescriptionEnMax = 255;

export const getBoardsConfig200ResponseDataItemDescriptionJaMax = 255;

export const getBoardsConfig200ResponseDataItemFixedTitleMax = 500;

export const GetBoardsConfig200Response = zod
    .object({
        data: zod
            .array(
                zod
                    .object({
                        board_config_id: zod.number().describe("Numeric primary key for the board configuration"),
                        board_id: zod
                            .enum([
                                "review",
                                "tiktoks",
                                "beauty_news",
                                "editorial_reviews",
                                "expert_reviews",
                                "activities",
                                "test_modal",
                                "test_modeless",
                                "guidance",
                            ])
                            .describe("Unique business key used by routes and board lookups"),
                        is_active: zod.number().describe("Board status: 1 = active, 0 = inactive"),
                        allowed_read_roles: zod
                            .array(zod.enum(["guest", "user", "expert", "moderator", "editor", "admin"]))
                            .describe("User roles allowed to read posts in this board"),
                        allowed_write_roles: zod
                            .array(zod.enum(["guest", "user", "expert", "moderator", "editor", "admin"]))
                            .describe("User roles allowed to write posts in this board"),
                        allowed_like_roles: zod
                            .array(zod.enum(["guest", "user", "expert", "moderator", "editor", "admin"]))
                            .describe("User roles allowed to like posts in this board"),
                        allowed_comment_roles: zod
                            .array(zod.enum(["guest", "user", "expert", "moderator", "editor", "admin"]))
                            .describe("User roles allowed to comment on posts in this board"),
                        comment_enabled: zod
                            .union([zod.literal(0), zod.literal(1)])
                            .describe("Comment feature: 1 = enabled, 0 = disabled"),
                        board_type: zod
                            .enum(["general", "news", "article", "review"])
                            .describe("Type\/category of the board"),
                        name_th: zod
                            .string()
                            .max(getBoardsConfig200ResponseDataItemNameThMax)
                            .optional()
                            .describe("Board name in Thai"),
                        name_en: zod
                            .string()
                            .max(getBoardsConfig200ResponseDataItemNameEnMax)
                            .describe("Board name in English"),
                        name_ja: zod
                            .string()
                            .max(getBoardsConfig200ResponseDataItemNameJaMax)
                            .optional()
                            .describe("Board name in Japanese"),
                        description_th: zod
                            .string()
                            .max(getBoardsConfig200ResponseDataItemDescriptionThMax)
                            .optional()
                            .describe("Board description in Thai"),
                        description_en: zod
                            .string()
                            .max(getBoardsConfig200ResponseDataItemDescriptionEnMax)
                            .optional()
                            .describe("Board description in English"),
                        description_ja: zod
                            .string()
                            .max(getBoardsConfig200ResponseDataItemDescriptionJaMax)
                            .optional()
                            .describe("Board description in Japanese"),
                        list_style: zod
                            .enum(["CARD", "LIST", "ONE_IMAGE_CARD", "TILES"])
                            .describe(
                                "Board card layout style: LIST = single-column review-style card, CARD = default tile grid, TILES = paginated 3x3 media-tile grid (SNS review style)",
                            ),
                        modal_usage: zod
                            .enum(["MODELESS", "MODELESS_TARGET_BLANK", "MODAL", "DIRECT_MAXIMIZE"])
                            .describe(
                                "Post details display method: MODELESS = same-tab page navigation, MODELESS_TARGET_BLANK = new-tab navigation, MODAL = in-page modal, DIRECT_MAXIMIZE = media click opens maximize viewer directly (no detail modal)",
                            ),
                        modal_size: zod
                            .enum(["small", "medium", "large", "extra-large", "N/A"])
                            .describe("Size of the modal for post details"),
                        title_enabled: zod
                            .union([zod.literal(0), zod.literal(1)])
                            .describe("Post title input visibility: 1 = enabled, 0 = hidden\/fixed"),
                        fixed_title: zod
                            .string()
                            .max(getBoardsConfig200ResponseDataItemFixedTitleMax)
                            .describe("Fixed title value used when title input is disabled"),
                        product_linker_show: zod
                            .enum(["SHOW", "HIDE"])
                            .describe("Product linker section visibility in post form: SHOW = visible, HIDE = hidden"),
                        target_product_show: zod
                            .enum(["SHOW", "HIDE"])
                            .describe(
                                "Target Product preview visibility on post detail page: SHOW = visible, HIDE = hidden",
                            ),
                        ogp_preview_show: zod
                            .enum(["SHOW", "HIDE"])
                            .describe(
                                "SNS link OGP preview visibility on post detail page: SHOW = visible, HIDE = hidden",
                            ),
                        user_info_show: zod
                            .enum(["SHOW", "HIDE"])
                            .describe(
                                "User info section visibility on post card and detail: SHOW = visible, HIDE = hidden",
                            ),
                        show_content: zod
                            .enum(["SHOW", "HIDE"])
                            .describe(
                                "Title and body text visibility in the white card area below media: SHOW = visible, HIDE = hidden",
                            ),
                        rating_overlay_show: zod
                            .enum(["SHOW", "HIDE"])
                            .describe(
                                "Rating\/recommend gradient overlay visibility on the card media area: SHOW = visible, HIDE = hidden",
                            ),
                        date_show: zod
                            .enum(["SHOW", "HIDE"])
                            .nullable()
                            .describe(
                                "Post date visibility in the top-right corner of the post detail view: SHOW = visible, HIDE = hidden, null = not set for this board",
                            ),
                        review_enabled: zod
                            .union([zod.literal(0), zod.literal(1)])
                            .describe("Review feature: 1 = enabled, 0 = disabled"),
                        review_config_id: zod
                            .number()
                            .nullish()
                            .describe(
                                "Review config id when review is enabled; null when review is disabled for this board",
                            ),
                        created_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Board creation timestamp"),
                        updated_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Board last update timestamp"),
                    })
                    .strict(),
            )
            .optional(),
        total: zod.number().optional(),
        current_page: zod.number().optional(),
        per_page: zod.number().optional(),
        last_page: zod.number().optional(),
    })
    .strict()
    .describe(
        "BoardConfigController::index() returns ServiceBase::getItems()'s raw shape directly — no success wrapper, and pagination fields are flat rather than nested under meta.",
    );

export const GetBoardsConfig400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();

export const GetBoardsConfig422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();

export const GetBoardsConfig500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Get specific board configuration by ID
 */
export const GetBoardConfigParams = zod
    .object({
        board_id: zod.enum([
            "review",
            "tiktoks",
            "beauty_news",
            "editorial_reviews",
            "expert_reviews",
            "activities",
            "test_modal",
            "test_modeless",
            "guidance",
        ]),
    })
    .strict();

export const getBoardConfig200ResponseItemNameThMax = 100;

export const getBoardConfig200ResponseItemNameEnMax = 100;

export const getBoardConfig200ResponseItemNameJaMax = 100;

export const getBoardConfig200ResponseItemDescriptionThMax = 255;

export const getBoardConfig200ResponseItemDescriptionEnMax = 255;

export const getBoardConfig200ResponseItemDescriptionJaMax = 255;

export const getBoardConfig200ResponseItemFixedTitleMax = 500;

export const GetBoardConfig200Response = zod
    .object({
        item: zod
            .object({
                board_config_id: zod.number().describe("Numeric primary key for the board configuration"),
                board_id: zod
                    .enum([
                        "review",
                        "tiktoks",
                        "beauty_news",
                        "editorial_reviews",
                        "expert_reviews",
                        "activities",
                        "test_modal",
                        "test_modeless",
                        "guidance",
                    ])
                    .describe("Unique business key used by routes and board lookups"),
                is_active: zod.number().describe("Board status: 1 = active, 0 = inactive"),
                allowed_read_roles: zod
                    .array(zod.enum(["guest", "user", "expert", "moderator", "editor", "admin"]))
                    .describe("User roles allowed to read posts in this board"),
                allowed_write_roles: zod
                    .array(zod.enum(["guest", "user", "expert", "moderator", "editor", "admin"]))
                    .describe("User roles allowed to write posts in this board"),
                allowed_like_roles: zod
                    .array(zod.enum(["guest", "user", "expert", "moderator", "editor", "admin"]))
                    .describe("User roles allowed to like posts in this board"),
                allowed_comment_roles: zod
                    .array(zod.enum(["guest", "user", "expert", "moderator", "editor", "admin"]))
                    .describe("User roles allowed to comment on posts in this board"),
                comment_enabled: zod
                    .union([zod.literal(0), zod.literal(1)])
                    .describe("Comment feature: 1 = enabled, 0 = disabled"),
                board_type: zod.enum(["general", "news", "article", "review"]).describe("Type\/category of the board"),
                name_th: zod
                    .string()
                    .max(getBoardConfig200ResponseItemNameThMax)
                    .optional()
                    .describe("Board name in Thai"),
                name_en: zod.string().max(getBoardConfig200ResponseItemNameEnMax).describe("Board name in English"),
                name_ja: zod
                    .string()
                    .max(getBoardConfig200ResponseItemNameJaMax)
                    .optional()
                    .describe("Board name in Japanese"),
                description_th: zod
                    .string()
                    .max(getBoardConfig200ResponseItemDescriptionThMax)
                    .optional()
                    .describe("Board description in Thai"),
                description_en: zod
                    .string()
                    .max(getBoardConfig200ResponseItemDescriptionEnMax)
                    .optional()
                    .describe("Board description in English"),
                description_ja: zod
                    .string()
                    .max(getBoardConfig200ResponseItemDescriptionJaMax)
                    .optional()
                    .describe("Board description in Japanese"),
                list_style: zod
                    .enum(["CARD", "LIST", "ONE_IMAGE_CARD", "TILES"])
                    .describe(
                        "Board card layout style: LIST = single-column review-style card, CARD = default tile grid, TILES = paginated 3x3 media-tile grid (SNS review style)",
                    ),
                modal_usage: zod
                    .enum(["MODELESS", "MODELESS_TARGET_BLANK", "MODAL", "DIRECT_MAXIMIZE"])
                    .describe(
                        "Post details display method: MODELESS = same-tab page navigation, MODELESS_TARGET_BLANK = new-tab navigation, MODAL = in-page modal, DIRECT_MAXIMIZE = media click opens maximize viewer directly (no detail modal)",
                    ),
                modal_size: zod
                    .enum(["small", "medium", "large", "extra-large", "N/A"])
                    .describe("Size of the modal for post details"),
                title_enabled: zod
                    .union([zod.literal(0), zod.literal(1)])
                    .describe("Post title input visibility: 1 = enabled, 0 = hidden\/fixed"),
                fixed_title: zod
                    .string()
                    .max(getBoardConfig200ResponseItemFixedTitleMax)
                    .describe("Fixed title value used when title input is disabled"),
                product_linker_show: zod
                    .enum(["SHOW", "HIDE"])
                    .describe("Product linker section visibility in post form: SHOW = visible, HIDE = hidden"),
                target_product_show: zod
                    .enum(["SHOW", "HIDE"])
                    .describe("Target Product preview visibility on post detail page: SHOW = visible, HIDE = hidden"),
                ogp_preview_show: zod
                    .enum(["SHOW", "HIDE"])
                    .describe("SNS link OGP preview visibility on post detail page: SHOW = visible, HIDE = hidden"),
                user_info_show: zod
                    .enum(["SHOW", "HIDE"])
                    .describe("User info section visibility on post card and detail: SHOW = visible, HIDE = hidden"),
                show_content: zod
                    .enum(["SHOW", "HIDE"])
                    .describe(
                        "Title and body text visibility in the white card area below media: SHOW = visible, HIDE = hidden",
                    ),
                rating_overlay_show: zod
                    .enum(["SHOW", "HIDE"])
                    .describe(
                        "Rating\/recommend gradient overlay visibility on the card media area: SHOW = visible, HIDE = hidden",
                    ),
                date_show: zod
                    .enum(["SHOW", "HIDE"])
                    .nullable()
                    .describe(
                        "Post date visibility in the top-right corner of the post detail view: SHOW = visible, HIDE = hidden, null = not set for this board",
                    ),
                review_enabled: zod
                    .union([zod.literal(0), zod.literal(1)])
                    .describe("Review feature: 1 = enabled, 0 = disabled"),
                review_config_id: zod
                    .number()
                    .nullish()
                    .describe("Review config id when review is enabled; null when review is disabled for this board"),
                created_at: zod.string().datetime({ offset: true }).optional().describe("Board creation timestamp"),
                updated_at: zod.string().datetime({ offset: true }).optional().describe("Board last update timestamp"),
            })
            .strict()
            .optional(),
    })
    .strict()
    .describe(
        "BoardConfigController::show() returns ServiceBase::getItem()'s raw ['item' => ...] shape directly — no success\/data wrapper.",
    );

export const GetBoardConfig400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(404), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();

export const GetBoardConfig404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(404), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();

export const GetBoardConfig422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(404), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();
